@if (data.mode === 'create') {
	<h2 mat-dialog-title>
		<span i18n="@@CreateGroup">Create Group</span>
		@if (data.parentGroupName) {
			<span class="subtitle"> &mdash; {{ data.parentGroupName }}</span>
		}
	</h2>
} @else {
	<h2 mat-dialog-title i18n="@@EditGroup">Edit Group</h2>
}

<mat-dialog-content style="padding-top: 12px;">
	<form [formGroup]="form" class="dialog-form">
		<mat-form-field appearance="outline" class="full-width">
			<mat-label i18n="@@GroupName">Name</mat-label>
			<input matInput formControlName="name" />
			@if (form.controls.name.touched && form.controls.name.hasError('required')) {
				<mat-error i18n="@@GroupNameIsRequired">Name is required</mat-error>
			}
		</mat-form-field>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button (click)="cancel()" i18n="@@Cancel">Cancel</button>
	<button matButton="elevated" color="primary" (click)="save()" i18n="@@Save">Save</button>
</mat-dialog-actions>
